export default __webpack_public_path__ + "static/media/fridge1-after1-480w.8525c280.webp";